// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { GroupSupervisoryStatus } from "./group-supervisory-status";

export class NormalGroupSupervisoryStatus implements flatbuffers.IUnpackableObject<NormalGroupSupervisoryStatusT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalGroupSupervisoryStatus {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalGroupSupervisoryStatus(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalGroupSupervisoryStatus,
  ): NormalGroupSupervisoryStatus {
    return (obj || new NormalGroupSupervisoryStatus()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsNormalGroupSupervisoryStatus(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalGroupSupervisoryStatus,
  ): NormalGroupSupervisoryStatus {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalGroupSupervisoryStatus()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  message(): GroupSupervisoryStatus {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : GroupSupervisoryStatus.UpPeak;
  }

  static startNormalGroupSupervisoryStatus(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, message: GroupSupervisoryStatus) {
    builder.addFieldInt16(0, message, GroupSupervisoryStatus.UpPeak);
  }

  static endNormalGroupSupervisoryStatus(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNormalGroupSupervisoryStatus(
    builder: flatbuffers.Builder,
    message: GroupSupervisoryStatus,
  ): flatbuffers.Offset {
    NormalGroupSupervisoryStatus.startNormalGroupSupervisoryStatus(builder);
    NormalGroupSupervisoryStatus.addMessage(builder, message);
    return NormalGroupSupervisoryStatus.endNormalGroupSupervisoryStatus(builder);
  }

  unpack(): NormalGroupSupervisoryStatusT {
    return new NormalGroupSupervisoryStatusT(this.message());
  }

  unpackTo(_o: NormalGroupSupervisoryStatusT): void {
    _o.message = this.message();
  }

  unpackFields(...fields: string[]): NormalGroupSupervisoryStatusT {
    const t = new NormalGroupSupervisoryStatusT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    return t;
  }
}

export class NormalGroupSupervisoryStatusT implements flatbuffers.IGeneratedObject {
  constructor(public message: GroupSupervisoryStatus = GroupSupervisoryStatus.UpPeak) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NormalGroupSupervisoryStatus.createNormalGroupSupervisoryStatus(builder, this.message);
  }

  clone(): NormalGroupSupervisoryStatusT {
    const obj = new NormalGroupSupervisoryStatusT();
    obj.message = this.message;
    return obj;
  }

  equals(other: NormalGroupSupervisoryStatusT): boolean {
    if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalGroupSupervisoryStatus(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
